enum DAO_TOKENS_PARAMS {
    TOKEN_NAME = 'tokenName',
    TOKEN_SYMBOL = 'tokenSymbol',
    BALANCE_USD = 'daosTotalUsdValue',
    ORGANIZATIONS = 'numDaos',
}

export { DAO_TOKENS_PARAMS };
